import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  jsonReader2agwreccj3lmk as jsonReader,
  jsonReaderkr2c3w0efm9b as jsonReader_0,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toApolloResponse9u5mcqg84l2p as toApolloResponse,
  parseResponse2l74cu4whks78 as parseResponse,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { Token_NULL_getInstance2d65is50ce53 as Token_NULL_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReader.mjs';
import { readErrors1y0wtxnlur21l as readErrors } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/internal/ResponseParser.mjs';
import {
  RouterError3i6hxcnqsy5l3 as RouterError,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloException16lek20l78zc3 as ApolloException,
  ApolloHttpException3o30u8ntkffuh as ApolloHttpException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  flowOf16f7h10nre075 as flowOf,
  flow3tazazxj2t7g4 as flow,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  multipartBodyFlow272n2l39kgnug as multipartBodyFlow,
  get_isGraphQLResponse3ogjhw8yzfes1 as get_isGraphQLResponse,
  get_isMultipart1je26zsopcnca as get_isMultipart,
} from '../../internal/multipart.mjs';
import { catchrcnx5mlu3pkp as catch_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import { currentTimeMillis8vwamy6polhm as currentTimeMillis } from '../../../../../../apollo-kotlin-apollo-mpp-utils/com/apollographql/apollo/mpp/utils.mjs';
import { HttpInfo25xgxbxy3emkc as HttpInfo } from './HttpExecutionContext.mjs';
import {
  dispose2t7a37uqicel0 as dispose,
  HttpInterceptor2khzkwmar9lg6 as HttpInterceptor,
  DefaultHttpInterceptorChain22k3s5gesb9pu as DefaultHttpInterceptorChain,
} from './HttpInterceptor.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstancefhanbu89c1sm as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { DefaultHttpRequestComposer3cbqxfvy17yg2 as DefaultHttpRequestComposer } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/DefaultHttpRequestComposer.mjs';
import { DefaultHttpEngine26xguluicr03l as DefaultHttpEngine } from './DefaultHttpEngine.js.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { emitAll157ci673e68ia as emitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Key_getInstance3kkpczi3zr320 as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { equals2v6cggk171b6e as equals_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HttpNetworkTransport$execute$slambda$o$collect$slambda($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$unsafeFlow;
    var it = value;
    var tmp$ret$1 = withHttpInfo(this$0, it, $request.q43_1, $httpResponse, $millisStart);
    yield* tmp0.q1e(tmp$ret$1, $completion);
    return Unit_instance;
  }), 1);
}
function HttpNetworkTransport$multipleResponses$o$collect$slambda($$this$unsafeFlow, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$unsafeFlow;
    var tmp2 = value;
    $l$block: {
      var tmp;
      if (isInterface($operation, Subscription())) {
        // Inline function 'kotlin.apply' call
        var this_0 = jsonReader_0(tmp2);
        var tmp0_elvis_lhs = $request.b44_1;
        this_0.o4f(tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs);
        var reader = this_0;
        var payloadResponse = null;
        var errors = null;
        reader.c41();
        while (reader.q1()) {
          switch (reader.e41()) {
            case 'payload':
              if (reader.t40().equals(Token_NULL_getInstance())) {
                reader.s40();
              } else {
                payloadResponse = parseResponse(reader, $operation, VOID, $customScalarAdapters, null);
              }

              break;
            case 'errors':
              if (reader.t40().equals(Token_NULL_getInstance())) {
                reader.s40();
              } else {
                errors = readErrors(reader);
              }

              break;
            default:
              reader.s40();
              break;
          }
        }
        reader.d41();
        var tmp_0;
        if (!(errors == null)) {
          tmp_0 = errorResponse(this$0, $operation, RouterError().h4h(errors));
        } else if (!(payloadResponse == null)) {
          tmp_0 = payloadResponse;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      } else {
        if ($incrementalResultsMerger._v == null) {
          $incrementalResultsMerger._v = this$0.e69_1.x67();
        }
        var merged = $incrementalResultsMerger._v.i68(tmp2);
        var deferredFragmentIdentifiers = $incrementalResultsMerger._v.f68();
        var isLast = !$incrementalResultsMerger._v.g68();
        var tmp_1;
        if ($incrementalResultsMerger._v.h68()) {
          tmp_1 = null;
        } else {
          tmp_1 = toApolloResponse(jsonReader(merged), $operation, VOID, $customScalarAdapters, deferredFragmentIdentifiers).g44().x44(isLast).e3a();
        }
        tmp = tmp_1;
      }
      var tmp0_elvis_lhs_0 = tmp;
      var tmp_2;
      if (tmp0_elvis_lhs_0 == null) {
        break $l$block;
      } else {
        tmp_2 = tmp0_elvis_lhs_0;
      }
      var transformed = tmp_2;
      yield* tmp0.q1e(transformed, $completion);
    }
    return Unit_instance;
  }), 1);
}
function errorResponse($this, operation, throwable) {
  var tmp;
  if (throwable instanceof ApolloException()) {
    tmp = throwable;
  } else {
    tmp = ApolloNetworkException().a4a('Error while reading JSON response', throwable);
  }
  var apolloException = tmp;
  var tmp0_requestUuid = uuid4();
  return Builder().r44(operation, tmp0_requestUuid).w44(apolloException).x44(true).e3a();
}
function errorResponse_0($this, operation, httpResponse) {
  var tmp;
  if ($this.b69_1) {
    tmp = httpResponse.h4c();
  } else {
    var tmp0_safe_receiver = httpResponse.h4c();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.m6();
    }
    tmp = null;
  }
  var maybeBody = tmp;
  var apolloException = ApolloHttpException().b4h(httpResponse.c4c_1, httpResponse.d4c_1, maybeBody, 'Http request failed with status code `' + httpResponse.c4c_1 + '`');
  return flowOf(errorResponse($this, operation, apolloException));
}
function singleResponse($this, request, customScalarAdapters, httpResponse) {
  var operation = request.p43_1;
  // Inline function 'kotlin.apply' call
  var this_0 = jsonReader_0(ensureNotNull(httpResponse.h4c()));
  var tmp0_elvis_lhs = request.b44_1;
  this_0.o4f(tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs);
  var response = toApolloResponse(this_0, operation, VOID, customScalarAdapters, null).g44().s44(httpResponse.g4c_1).x44(true).e3a();
  return flowOf(response);
}
function multipleResponses($this, request, customScalarAdapters, httpResponse) {
  var incrementalResultsMerger = {_v: null};
  var operation = request.p43_1;
  // Inline function 'kotlinx.coroutines.flow.mapNotNull' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  var this_0 = multipartBodyFlow(httpResponse);
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  var tmp = new (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1())(this_0, operation, request, customScalarAdapters, $this, incrementalResultsMerger);
  return catch_0(tmp, HttpNetworkTransport$multipleResponses$slambda(operation, $this));
}
function wrapIfNeeded($this, $receiver) {
  var tmp;
  if ($receiver instanceof ApolloException()) {
    tmp = $receiver;
  } else {
    tmp = ApolloNetworkException().a4a('Error while reading response', $receiver);
  }
  return tmp;
}
function withHttpInfo($this, $receiver, requestUuid, httpResponse, millisStart) {
  // Inline function 'kotlin.apply' call
  var this_0 = $receiver.g44().z42(requestUuid);
  if (!(httpResponse == null)) {
    this_0.s44(new (HttpInfo())(millisStart, currentTimeMillis(), httpResponse.c4c_1, httpResponse.d4c_1));
  }
  return this_0.e3a();
}
var EngineInterceptorClass;
function EngineInterceptor() {
  if (EngineInterceptorClass === VOID) {
    class $ {
      constructor($outer) {
        this.g69_1 = $outer;
      }
      *u68(request, chain, $completion) {
        return yield* this.g69_1.z68_1.p68(request, $completion);
      }
    }
    protoOf($).n10 = dispose;
    initMetadataForClass($, 'EngineInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    EngineInterceptorClass = $;
  }
  return EngineInterceptorClass;
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.t64_1 = null;
        this.u64_1 = null;
        this.v64_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.w64_1 = ArrayList().p2();
        this.x64_1 = false;
        this.y64_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.z64_1 = ArrayList().p2();
      }
      a65(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.u64_1 = serverUrl;
        return this;
      }
      c65(exposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.x64_1 = exposeErrorBody;
        return this;
      }
      b65(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.v64_1 = httpEngine;
        return this;
      }
      d65(interceptors) {
        // Inline function 'kotlin.apply' call
        this.w64_1.y4();
        this.w64_1.u2(interceptors);
        return this;
      }
      e3a() {
        // Inline function 'kotlin.check' call
        if (!(this.t64_1 == null || this.u64_1 == null)) {
          var message = "It is an error to set both 'httpRequestComposer' and 'serverUrl'";
          throw IllegalStateException().o(toString(message));
        }
        var tmp0_elvis_lhs = this.t64_1;
        var composer = tmp0_elvis_lhs == null ? DefaultHttpRequestComposer().d4b(this.u64_1) : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.z64_1.n1()) {
          this.w64_1.j2(new (TransportHeadersInterceptor())(this.z64_1));
        }
        var tmp1_elvis_lhs = this.v64_1;
        return new (HttpNetworkTransport())(composer, tmp1_elvis_lhs == null ? DefaultHttpEngine() : tmp1_elvis_lhs, this.w64_1, this.x64_1, this.y64_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var TransportHeadersInterceptorClass;
function TransportHeadersInterceptor() {
  if (TransportHeadersInterceptorClass === VOID) {
    class $ {
      constructor(headers) {
        this.h69_1 = headers;
      }
      *u68(request, chain, $completion) {
        return yield* chain.x68(request.o4c().m4b(this.h69_1).e3a(), $completion);
      }
    }
    protoOf($).n10 = dispose;
    initMetadataForClass($, 'TransportHeadersInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    TransportHeadersInterceptorClass = $;
  }
  return TransportHeadersInterceptorClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.i69_1 = function_0;
      }
      *q1e(value, $completion) {
        return yield* $(this.i69_1(value, $completion), $completion);
      }
      j5() {
        return this.i69_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.j5(), other.j5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.j5());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
function sam$kotlinx_coroutines_flow_FlowCollector$0_0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 === VOID) {
    class $_0 {
      constructor(function_0) {
        this.j69_1 = function_0;
      }
      *q1e(value, $completion) {
        return yield* $(this.j69_1(value, $completion), $completion);
      }
      j5() {
        return this.j69_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.j5(), other.j5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.j5());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
}
var HttpNetworkTransport$execute$1$$inlined$map$1Class;
function HttpNetworkTransport$execute$1$$inlined$map$1() {
  if (HttpNetworkTransport$execute$1$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, this$0, $request, $httpResponse, $millisStart) {
        this.k69_1 = $this;
        this.l69_1 = this$0;
        this.m69_1 = $request;
        this.n69_1 = $httpResponse;
        this.o69_1 = $millisStart;
      }
      *p1e(collector, $completion) {
        var tmp = HttpNetworkTransport$execute$slambda$o$collect$slambda(collector, this.l69_1, this.m69_1, this.n69_1, this.o69_1);
        yield* this.k69_1.t1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      t1d(collector, $completion) {
        return this.p1e(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$execute$1$$inlined$map$1Class = $;
  }
  return HttpNetworkTransport$execute$1$$inlined$map$1Class;
}
function HttpNetworkTransport$execute$slambda(this$0, $httpRequest, $request, $customScalarAdapters) {
  return constructCallableReference(($this$flow, $completion) => orPromise($completion, function *($completion) {
    var millisStart = currentTimeMillis();
    var throwable = null;
    var tmp;
    try {
      tmp = yield* (new (DefaultHttpInterceptorChain())(this$0.f69_1, 0)).x68($httpRequest, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        if (t instanceof CancellationException()) {
          throw t;
        }
        throwable = t;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var httpResponse = tmp;
    var tmp_1;
    if (httpResponse == null) {
      tmp_1 = flowOf(errorResponse(this$0, $request.p43_1, ensureNotNull(throwable)));
    } else {
      var tmp_2;
      var containsArg = httpResponse.c4c_1;
      if (!(200 <= containsArg ? containsArg <= 299 : false)) {
        tmp_2 = !get_isGraphQLResponse(httpResponse);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = errorResponse_0(this$0, $request.p43_1, httpResponse);
      } else {
        if (get_isMultipart(httpResponse)) {
          tmp_1 = multipleResponses(this$0, $request, $customScalarAdapters, httpResponse);
        } else {
          tmp_1 = singleResponse(this$0, $request, $customScalarAdapters, httpResponse);
        }
      }
    }
    var responses = tmp_1;
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var tmp$ret$0 = new (HttpNetworkTransport$execute$1$$inlined$map$1())(responses, this$0, $request, httpResponse, millisStart);
    yield* emitAll($this$flow, tmp$ret$0, $completion);
    return Unit_instance;
  }), 1);
}
var HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
function HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1() {
  if (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class === VOID) {
    class $ {
      constructor($this, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger) {
        this.p69_1 = $this;
        this.q69_1 = $operation;
        this.r69_1 = $request;
        this.s69_1 = $customScalarAdapters;
        this.t69_1 = this$0;
        this.u69_1 = $incrementalResultsMerger;
      }
      *p1e(collector, $completion) {
        var tmp = HttpNetworkTransport$multipleResponses$o$collect$slambda(collector, this.q69_1, this.r69_1, this.s69_1, this.t69_1, this.u69_1);
        yield* this.p69_1.t1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0_0())(tmp), $completion);
        return Unit_instance;
      }
      t1d(collector, $completion) {
        return this.p1e(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class = $;
  }
  return HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
}
function HttpNetworkTransport$multipleResponses$slambda($operation, this$0) {
  return constructCallableReference(($this$catch, throwable, $completion) => orPromise($completion, function *($completion) {
    yield* $this$catch.q1e(Builder().r44($operation, uuid4()).w44(wrapIfNeeded(this$0, throwable)).e3a(), $completion);
    return Unit_instance;
  }), 2);
}
var HttpNetworkTransportClass;
function HttpNetworkTransport() {
  if (HttpNetworkTransportClass === VOID) {
    class $ {
      constructor(httpRequestComposer, engine, interceptors, exposeErrorBody, incrementalDeliveryProtocol) {
        this.y68_1 = httpRequestComposer;
        this.z68_1 = engine;
        this.a69_1 = interceptors;
        this.b69_1 = exposeErrorBody;
        this.c69_1 = incrementalDeliveryProtocol;
        this.d69_1 = new (EngineInterceptor())(this);
        this.e69_1 = get_impl(this.c69_1);
        this.f69_1 = plus(this.a69_1, this.d69_1);
      }
      h66(request) {
        var customScalarAdapters = ensureNotNull(request.t43_1.p48(Key_getInstance()));
        var tmp;
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs = request.w43_1;
        var tmp0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'kotlin.collections.none' call
          var tmp_0;
          if (isInterface(tmp0, Collection())) {
            tmp_0 = tmp0.n1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$1 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (equals_0(element.u4b_1, 'accept', true)) {
              tmp$ret$1 = false;
              break $l$block_0;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          var tmp_1;
          var tmp_2 = request.p43_1;
          if (isInterface(tmp_2, Subscription())) {
            tmp_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
          } else {
            tmp_1 = this.e69_1.w67();
          }
          var accept = tmp_1;
          tmp = request.g44().f43('accept', accept).e3a();
        } else {
          tmp = request;
        }
        var request_0 = tmp;
        var httpRequest = this.y68_1.e4b(request_0);
        return this.v69(request_0, httpRequest, customScalarAdapters);
      }
      v69(request, httpRequest, customScalarAdapters) {
        return flow(HttpNetworkTransport$execute$slambda(this, httpRequest, request, customScalarAdapters));
      }
      n10() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.a69_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.n10();
        }
        this.z68_1.m6();
      }
    }
    initMetadataForClass($, 'HttpNetworkTransport');
    HttpNetworkTransportClass = $;
  }
  return HttpNetworkTransportClass;
}
//region block: exports
export {
  Builder_0 as Builder3d75eph7uovs3,
};
//endregion

//# sourceMappingURL=HttpNetworkTransport.mjs.map
